module.exports = __webpack_public_path__ + "assets/img/13.28f91075.png";